import { validateEscriptToken } from '@montugroup/circuit-shared/utils/escript';
import { Checkbox, Typography } from '@montugroup/design-system';

import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import { Controller, useFormContext } from 'react-hook-form';
import { TokenInputField } from './TokenInputField';
import type { SubmitTokenUnion } from './types';

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  alignItems: 'flex-start',
  marginTop: theme.spacing(4),
}));

export function TokenInputWithAgreement() {
  const {
    control,
    formState: { errors },
  } = useFormContext<SubmitTokenUnion>();

  return (
    <>
      <Controller
        name="tokenInput"
        control={control}
        rules={{
          required: 'Please enter your script token',
          validate: validateEscriptToken,
        }}
        render={({ field, fieldState }) => (
          <TokenInputField field={field} fieldState={fieldState} formErrors={errors} />
        )}
      />

      <Controller
        name="agreementCheckbox"
        control={control}
        render={({ field: { onChange, value, ref } }) => (
          <StyledFormControlLabel
            control={<Checkbox checked={value} onChange={onChange} inputRef={ref} color="primary" />}
            label={
              <Typography variant="body2" sx={(theme) => ({ paddingTop: theme.spacing(2) })}>
                I confirm that the customer understands and agrees that uMeds can access their personal and prescription
                information using the encrypted payload from eRx (electronic prescription) for the purpose of ordering
                medication.
              </Typography>
            }
          />
        )}
      />
    </>
  );
}
